"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _ContactAPI = _interopRequireDefault(require("../api/ContactAPI"));

var contactAPI = new _ContactAPI.default();

var ContactTracker =
/*#__PURE__*/
function () {
  function ContactTracker() {
    (0, _classCallCheck2.default)(this, ContactTracker);
  }

  (0, _createClass2.default)(ContactTracker, [{
    key: "saveContact",
    value: function saveContact(contactEmail, websiteGrade) {
      // Store on the HubSpot portal
      contactAPI.save(contactEmail, websiteGrade);
    }
  }]);
  return ContactTracker;
}();

var _default = new ContactTracker();

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/lib/contactTracker.js
// module id = 252
// module chunks = 0